export const preventBodyScroll = (preventScroll: boolean) => {
  let previousOverflow = "";
  let previousPaddingRight = "";

  // Получаем ширину документа для плавного скрытия полосы прокрутки
  const { width } = document.body.getBoundingClientRect();

  if (preventScroll) {
    previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = previousOverflow;
  }

  // Получаем новую ширину тега body, чтобы рассчитать ширину полосы прокрутки
  const { width: newWidth } = document.body.getBoundingClientRect();
  const scrollBarWidth = newWidth - width;

  // С помощью правого отступа компенсируем разницу в отсутствии полосы прокрутки
  if (preventScroll) {
    previousPaddingRight = document.body.style.paddingRight;
    document.body.style.paddingRight = `${Math.max(0, scrollBarWidth || 0)}px`;
  } else {
    document.body.style.paddingRight = previousPaddingRight;
  }
};
